var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecretsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_9098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_9098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 26.2241C9.45 26.2241 8.97917 26.0283 8.5875 25.6366C8.19583 25.245 8 24.7741 8 24.2241V14.2241C8 13.6741 8.19583 13.2033 8.5875 12.8116C8.97917 12.42 9.45 12.2241 10 12.2241H11V10.2241C11 8.84079 11.4875 7.66162 12.4625 6.68662C13.4375 5.71162 14.6167 5.22412 16 5.22412C17.3833 5.22412 18.5625 5.71162 19.5375 6.68662C20.5125 7.66162 21 8.84079 21 10.2241V12.2241H22C22.55 12.2241 23.0208 12.42 23.4125 12.8116C23.8042 13.2033 24 13.6741 24 14.2241V24.2241C24 24.7741 23.8042 25.245 23.4125 25.6366C23.0208 26.0283 22.55 26.2241 22 26.2241H10ZM10 24.2241H22V14.2241H10V24.2241ZM16 21.2241C16.55 21.2241 17.0208 21.0283 17.4125 20.6366C17.8042 20.245 18 19.7741 18 19.2241C18 18.6741 17.8042 18.2033 17.4125 17.8116C17.0208 17.42 16.55 17.2241 16 17.2241C15.45 17.2241 14.9792 17.42 14.5875 17.8116C14.1958 18.2033 14 18.6741 14 19.2241C14 19.7741 14.1958 20.245 14.5875 20.6366C14.9792 21.0283 15.45 21.2241 16 21.2241ZM13 12.2241H19V10.2241C19 9.39079 18.7083 8.68245 18.125 8.09912C17.5417 7.51579 16.8333 7.22412 16 7.22412C15.1667 7.22412 14.4583 7.51579 13.875 8.09912C13.2917 8.68245 13 9.39079 13 10.2241V12.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretsIcon);
export default __webpack_public_path__ + "static/media/Secrets_icon.7607707b0a95248f0e3594900d2ce60b.svg";
export { ForwardRef as ReactComponent };